import React from 'react'
import SmartphoneOffIcon from 'transfix-icons/build/SmartphoneOffIcon'
import SmartphoneOnIcon from 'transfix-icons/build/SmartphoneOnIcon'
import { ITeamMember } from 'apps/fleet-planner/types/teamMember'
import { hasDrivers } from 'utils/teamMemberHelpers'

interface ITeamMemberSmsOptInDisplayProps {
  teamMember: ITeamMember
}

const TeamMemberSmsOptInDisplay = ({ teamMember }: ITeamMemberSmsOptInDisplayProps) => {
  const { motorCarrierDetails, smsStatusUpdatesEnabled } = teamMember || {}
  const isDriver = hasDrivers(motorCarrierDetails)

  if (!isDriver) {
    return <span>N/A</span>
  }

  return smsStatusUpdatesEnabled ? (
    <SmartphoneOnIcon size='large' />
  ) : (
    <SmartphoneOffIcon size='large' />
  )
}

export default TeamMemberSmsOptInDisplay
